import { UserManager } from 'oidc-client-ts';
import clientSettings from '../client-settings';

const oidcConfig = {
    authority: clientSettings.userManagerSettings.authority || '',
    client_id: clientSettings.userManagerSettings.client_id || '',
    redirect_uri: clientSettings.userManagerSettings.redirect_uri || '',
    response_type: 'code',
    scope: 'openid profile email livedocApi',
    // storage: localStorage,
};

console.log({ oidcConfig });

export const userManager = new UserManager(oidcConfig);
